<template>
  <div class="row">
    <div class="col-sm-8">
      <div class="panel panel-default">
        <div class="panel-body">
          <loader-box v-if="loading"/>
          <form method="POST" :action="url" @submit.prevent="submitSms">
            <input type="hidden" name="_token" v-model="sms._token">
            <div class="form-group">
              <label for="to" class="control-label">Destinataire</label>
              <input type="text" name="to_names" id="to" class="form-control" v-model="recipientsNames" disabled>
              <input type="hidden" v-model="recipientsIds" name="to">
            </div>
            <div class="form-group">
              <label for="message" class="control-label">Message</label>
              <textarea style="min-height: 300px" name="message" id="message" class="form-control" v-model="sms.message"></textarea>
            </div>
            <button class="btn btn-block btn-primary">Envoyer <i class="fa fa-send-o"></i></button>
          </form>
        </div>
      </div>
      <div class="panel panel-default" v-if="smsRender">
        <div class="panel-body" v-html="smsRender"></div>
      </div>
      <div class="panel" :class="'panel-' + flash.type" v-if="flash.message">
        <div class="panel-body">{{ flash.message }}</div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="list-group">
        <a v-for="key in Object.keys(variables)" href="#" class="list-group-item" @click.prevent="addVariable(key)">
          <h4 class="list-group-item-heading">{{ key }}</h4>
          <p class="list-group-item-text">{{ variables[key] }}</p>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
  import appAxios from '../../app-axios'
  import LoaderBox from '../Loader/LoaderBox'
  export default {
    props: {
      csrfToken: {type: String},
      url: {type: String},
      returnUrl: {type: String},
      variablesJson: {type: String},
      dummyUserJson: {type: String},
      recipientsJson: {type: String},
    },
    components: {
      LoaderBox
    },
    data () {
      return {
        loading: false,
        sms: {
          _token: '',
          message: ':greetings :full_name,:space',
          to: ''
        },
        flash: {
          type: 'info',
          message: ''
        }
      }
    },
    computed: {
      recipientsNames () {
        return Object.values(this.recipients).join(', ')
      },
      recipientsIds () {
        return Object.keys(this.recipients).join(', ')
      },
      smsRender () {
        let message = this.sms.message
        Object.keys(this.variables).forEach(key => {
          message = message.split(key).join(this.dummyUser[key])
        })
        return message
      },
      variables () {
        return JSON.parse(this.variablesJson)
      },
      dummyUser () {
        return JSON.parse(this.dummyUserJson)
      },
      recipients () {
        return JSON.parse(this.recipientsJson)
      }
    },
    methods: {
      addVariable (key) {
        this.sms.message += ' ' + key + ' '
      },
      submitSms () {
        this.loading = true
        this.sms.to = Object.keys(this.recipients)
        appAxios.post(this.url, this.sms)
          .then(apiResponse => {
            if (apiResponse.isSuccess()) {
              this.flash.type = apiResponse.getType()
              this.flash.message = apiResponse.getMessage()
              setTimeout(() => {
                window.location = this.returnUrl
              }, 5000)
            } else {
              console.error(apiResponse)
            }
          })
          .catch(apiResponse => {
            console.error(apiResponse)
            debugger
          })
          .then(_ => this.loading = false)
      }
    },
    mounted () {
      this.sms._token = this.csrfToken
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/component/Sms/SmsCompose.vue